export { default } from './SmallCenteredText';
export type { IPrismicSmallCenteredTextPrimary } from './types';
